var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M22.02 1.002S17.301 7.168 11.5 7.168C5.7 7.168.78.871 1.009 1.002M11.5 9.89V7.168M21.086 5.66l-1.261-2.133M16.798 8.71l-.732-2.526M6.204 8.71l.757-2.526M1.916 5.66l1.26-2.133"
  })));
};
export default SvgEyeClosed;